import { createApp } from "vue";
import PortalVue from "portal-vue";
import App from "~/App";
import * as baseComponents from "~/components/base";
import confirm from "~/components/dialogs/Confirm";
import confirmDanger from "~/components/dialogs/ConfirmDanger";
import confirmDelete from "~/components/dialogs/ConfirmDelete";
import confirmDeleteStayEventsOnEvents from "~/components/dialogs/ConfirmDeleteStayEventsOnEvents";
import confirmExamRegistrationDeregistration from "~/components/dialogs/ConfirmExamRegistrationDeregistration";
import confirmExtensionPoolRequest from "~/components/dialogs/ConfirmExtensionPoolRequest";
import confirmNoteClose from "~/components/dialogs/ConfirmNoteClose";
import confirmQueuePayChecks from "~/components/dialogs/ConfirmQueuePayChecks";
import confirmRestore from "~/components/dialogs/ConfirmRestore";
import confirmStayTermination from "~/components/dialogs/ConfirmStayTermination";
import deleteEvent from "~/components/dialogs/DeleteEvent";
import deleteLeaveRequest from "~/components/dialogs/DeleteLeaveRequest";
import deleteSickNote from "~/components/dialogs/DeleteSickNote";
import deleteUser from "~/components/dialogs/DeleteUser";
import defaultDialog from "~/components/dialogs/Dialog";
import getConflictResolution from "~/components/dialogs/GetConflictResolution";
import getEventContext from "~/components/dialogs/GetEventContext";
import selectAbsenceType from "~/components/dialogs/SelectAbsenceType";
import selectClearingChannel from "~/components/dialogs/SelectClearingChannel";
import stayDeletionBlocked from "~/components/dialogs/StayDeletionBlocked";
import updateLeaveRequest from "~/components/dialogs/UpdateLeaveRequest";
import updateSickNote from "~/components/dialogs/UpdateSickNote";
import SvgIcon from "~/components/icons/SvgIcon";
import { highlightAnchorDirective } from "~/directives/highlightAnchor";
import { tooltip } from "~/directives/tooltip";
import { dialogsPlugin } from "~/plugins/dialogs";
import { errorHandler } from "~/plugins/errorHandler";
import { features } from "~/plugins/features";
import { filters } from "~/plugins/filters";
import { modals } from "~/plugins/modals";
import { toasts } from "~/plugins/toast";
import { router } from "~/router";
import { store } from "~/store";
import { installChunkLoadRecovery } from "~/utils/chunkLoadRecovery";
import { initSentry } from "~/utils/sentryConfig";
import { apolloProvider } from "~/vue-apollo";

const app = createApp(App);

app.use(router);
app.use(store);
app.use(apolloProvider);
app.use(toasts);
app.use(filters);
app.use(modals);
app.use(errorHandler);
app.use(features);

app.use(dialogsPlugin, {
  default: defaultDialog,
  dialogs: {
    confirm,
    confirmDanger,
    confirmDelete,
    confirmExtensionPoolRequest,
    confirmNoteClose,
    confirmQueuePayChecks,
    confirmRestore,
    confirmStayTermination,
    confirmDeleteStayEventsOnEvents,
    confirmExamRegistrationDeregistration,
    deleteEvent,
    deleteLeaveRequest,
    deleteSickNote,
    deleteUser,
    getConflictResolution,
    getEventContext,
    selectAbsenceType,
    selectClearingChannel,
    stayDeletionBlocked,
    updateLeaveRequest,
    updateSickNote,
  },
});

app.use(PortalVue);
initSentry(app);

app.directive("tooltip", tooltip);
app.directive("highlight-anchor", highlightAnchorDirective);

app.component("Svgicon", SvgIcon);

Object.entries(baseComponents).forEach(([name, definition]) => app.component(name, definition));

// Before mounting: mounting resolves the first route, which is already a lazy
// import that can fail.
installChunkLoadRecovery();

app.mount("#app");
